import { render, staticRenderFns } from "./authorizationinfo.vue?vue&type=template&id=d7a6b6cc&scoped=true&"
import script from "./authorizationinfo.vue?vue&type=script&lang=js&"
export * from "./authorizationinfo.vue?vue&type=script&lang=js&"
import style0 from "./authorizationinfo.vue?vue&type=style&index=0&id=d7a6b6cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a6b6cc",
  null
  
)

export default component.exports